import React from "react"
import { Grid } from "@mui/material"
import ReportManualExecutionSwitch from "./ManualExecution"
import ReportFrequencyHoursField from "./FrequencyHours"
import ReportFrequencyDaysField from "./FrequencyDays"
import MultipleModalFrequencyInfoSection from "Pages/ReportsAlerts/Reports/@components/MultipleModal/Content/FrequencySection/Info"


export default function ReportMultiModalFrequencySection() {


	return <Grid container spacing={2}>
		<Grid item xs={12}>
			<ReportManualExecutionSwitch/>
		</Grid>
		<Grid item xs={6}>
			<ReportFrequencyHoursField/>
		</Grid>
		<Grid item xs={6}>
			<ReportFrequencyDaysField/>
		</Grid>
		<Grid item xs={8}>
			<MultipleModalFrequencyInfoSection/>
		</Grid>
	</Grid>
}